export default __webpack_public_path__ + "static/media/avatar_99.f5ee2ab9.png";